import React, {PropTypes} from "react";
import Card from "./components/Card";
import Picker from "react-month-picker";
import axios from 'axios';
import toastr from 'toastr';

class AnnouncementsHomePage extends React.Component {

  constructor() {
    super();
    this.state = {mrange: {from: {year: 2017, month: 1}, to: {year: 2017, month: 12}},announcements:[]}
    this.handleRangeDissmis = this.handleRangeDissmis.bind(this);
    this.deleteAnnouncement = this.deleteAnnouncement.bind(this);
  }

  handleRangeDissmis(value) {
    console.log(value.from.month);
    let startDate = new Date();
    let endDate = new Date();
    startDate.setYear(2017); endDate.setYear(2017);
    startDate.setDate(1); endDate.setDate(1);
    startDate.setMonth(value.from.month-1); endDate.setMonth(value.to.month-1);
    console.log(startDate);
    let requestObject={
      category: "Quikr_Inspector",
      from: startDate,
      to: endDate,
    }

    axios.get(process.env.REQ_URL + "/chatter/getAnnouncements?q="+JSON.stringify(requestObject), {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      console.log(response.data.data);
      this.setState({announcements: response.data.data});
    }).catch((error) => {

    });



    this.setState({mrange: value});
  }
  componentDidMount()
  {
    this.props.changeBanner("Quikr Inspectr");
    let startDate = new Date();
    let endDate = new Date();
    startDate.setYear(2017); endDate.setYear(2017);
    startDate.setDate(1); endDate.setDate(31);
    startDate.setMonth(0); endDate.setMonth(11);

    let requestObject={
      category: "Quikr_Inspector",
      from: startDate,
      to: endDate,
    }

    axios.get(process.env.REQ_URL + "/chatter/getAnnouncements?q="+JSON.stringify(requestObject), {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      console.log(response.data.data);
      this.setState({announcements: response.data.data});
    }).catch((error) => {

    });

  }
  deleteAnnouncement(id)
  {
    console.log("reached here");
    axios.post(process.env.REQ_URL + "/chatter/deleteAnnouncement",{id: id}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      toastr.success("Deleted");
      this.componentDidMount();
    }).catch((error) => {

    });

  }

  render() {
    let pickerLang = {
      months: ['Jan', 'Feb', 'Mar', 'Spr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      , from: 'From', to: 'To'
    }
      , mvalue = {year: 2015, month: 11}
      , mrange = {from: {year: 2014, month: 8}, to: {year: 2015, month: 5}}

    let makeText = m => {
      if (m && m.year && m.month) return (pickerLang.months[m.month - 1] + '. ' + m.year)
      return '?'
    };

    return (
      <div className="col-md-12">
        <br/>
        <div className="col-md-12">
          <button className="btn btn-default" onClick={()=> {
            this.refs.pickRange.show()
          }}>Select Months
          </button>
          &nbsp; &nbsp;
          <font style={{fontSize: '16px',align: 'center'}}>{makeText(this.state.mrange.from) + " to " + makeText(this.state.mrange.to)}</font>


          <Picker
            ref="pickRange"

            years={{min: {year: 2017, month: 1}, max: {year: 2017, month: 12}}}
            range={this.state.mrange}
            lang={pickerLang}
            theme="light"
            onChange={this.handleRangeChange}
            onDismiss={this.handleRangeDissmis}
          >


          </Picker>
        </div>

        <br/>
        <div className="col-md-10">

          {this.state.announcements.map((node)=>{
            return <Card
              deleteAnnouncement={this.deleteAnnouncement}
              employee={this.props.employee}
              data={node}/>;
          })}
          {this.state.announcements.length==0?<h4>No announcements to display</h4>:null}

        </div>
      </div>
    );
  }
}

AnnouncementsHomePage.defaultProps = {}

AnnouncementsHomePage.propTypes = {};

export default AnnouncementsHomePage;





/** WEBPACK FOOTER **
 ** ./src/feature/announcements/DogFoodingHome.js
 **/